import type { SquishShape } from '@usespaceui/squishmoji';

// Alternate organic, geometric, and character silhouettes so adjacent morphs read clearly.
const SHAPES = [
  'square',
  'cloud',
  'triangle',
  'pebble',
  'star',
  'capsule',
  'cat',
  'hexagon',
  'drop',
  'flower',
  'bot',
  'circle',
  'ghost',
  'pentagon',
  'ufo',
  'squircle',
  'alien',
  'octagon',
  'lion',
  'monkey',
  'mecha',
] as const satisfies readonly SquishShape[];

export const ACTIVITY_SHAPE_SEQUENCE = SHAPES.map((shape) => ({
  shape,
  holdMs: 320,
}));
export const ACTIVITY_SHAPE_MORPH_MS = 900;
